import { Component } from "react";
import PropTypes from "prop-types";
import SimpleRenderer from "./SimpleRenderer";
import { numberWithSpaces } from "../../../../utilities/formaters";
import moment from "moment";

export default class GeneralInformationRenderer extends Component {
  render() {
    const item = this.props.item;

    return (
      <div>
        <h4>General Information</h4>

        <SimpleRenderer label={"Account ID:"} text={[item.AccountId]} />
        <SimpleRenderer label={"Loan internal ID:"} text={[item.Id]} />
        <SimpleRenderer label={"Loan ID:"} text={[item.Guid]} />
        <SimpleRenderer
          label={"Issue Date"}
          text={[
            item.IssueDate
              ? moment(item.IssueDate).format("YYYY-MM-DD - HH:mm:ss")
              : "Not Issued",
          ]}
        />
        {/*<SimpleRenderer label={'SelectedAccount'} text={['Number ' + '' + '']} />*/}
        <SimpleRenderer
          label={"Loan Info"}
          text={[
            "Amount: " + numberWithSpaces(item.Amount.Amount) + " kr",
            "Payout Amount: " +
              numberWithSpaces(item.PayoutAmount.Amount) +
              " kr",
            "InitFee: " + numberWithSpaces(item.InitFee.Amount) + " kr",
            "Type: " + item.CreditType,
            "Intrest: " +
              numberWithSpaces(item.NominalInterest.Value * 100, 3) +
              "%",
            "Intermediation Fee: " +
              numberWithSpaces(item.IntermediationFee.Amount) +
              " kr",
            "AdminFee: " + numberWithSpaces(item.InvoiceFee.Amount) + " kr",
            "Loan term: " + item.LoanTerm + " months",
            "Loan OCR: " + item.OCR,
            "UpSwitchable: " + getUpSwitchInfo(item),
          ]}
        />
        <SimpleRenderer
          label={"Excess payment"}
          text={[
            "ExcessPayment: " +
              numberWithSpaces(item.ExcessPayment.Amount) +
              " kr",
          ]}
        />
      </div>
    );

    function getUpSwitchInfo(item) {
      if (item.CanUpSwitch) {
        return (
          "Yes (" +
          numberWithSpaces(item.MinUpSwitchAmount.Amount) +
          " kr - " +
          numberWithSpaces(item.MaxUpSwitchAmount.Amount) +
          " kr)"
        );
      } else {
        return "No";
      }
    }
  }

  static propTypes = {
    item: PropTypes.object,
  };
}
